import { useTemplateDetailsStore } from '@store/templateDetailsStore';
import useMemoLanguageOptions from './useMemoLanugageOptions';

export default function useAvailableLanguageOptions() {
  const editor = useTemplateDetailsStore((s) => s.editor);

  const availableLangOptions = useMemoLanguageOptions(editor);

  return availableLangOptions;
}
